import { useState } from "react";
import Button from "../UI/Button";
import Input from "../UI/Input";
import styles from "./NewExpenseForm.module.css";
import NewExpenseFormMessage from "./NewExpenseFormMessage";

const NewExpenseForm = (props) => {
  const [enteredValue, setEnteredValue] =
    useState({
      enteredTitle: "",
      enteredAmount: "",
      enteredDate: "",
    });
  const [isValid, setIsValid] = useState(true);
  const [message, setMessage] = useState({
    type: "",
    message: "",
  });

  const changeTitleHandler = (event) => {
    const enteredTitle = event.target.value;
    setEnteredValue((prevValue) => {
      return { ...prevValue, enteredTitle };
    });
  };
  const changeAmountHandler = (event) => {
    const enteredAmount = event.target.value;
    setEnteredValue((prevValue) => {
      return { ...prevValue, enteredAmount };
    });
  };
  const changeDateHandler = (event) => {
    const enteredDate = event.target.value;
    setEnteredValue((prevValue) => {
      return { ...prevValue, enteredDate };
    });
  };
  const submitFormHandler = (event) => {
    event.preventDefault();
    const enteredTitle =
      enteredValue.enteredTitle;
    const enteredAmount =
      enteredValue.enteredAmount;
    const enteredDate = enteredValue.enteredDate;
    if (
      enteredTitle.trim().length > 0 &&
      enteredAmount.trim().length > 0 &&
      enteredDate.trim().length > 0
    ) {
      const newExpenseData = {
        enteredTitle,
        enteredAmount,
        enteredDate,
      };
      setEnteredValue((prevValue) => {
        return {
          ...prevValue,
          enteredTitle: "",
          enteredAmount: "",
          enteredDate: "",
        };
      });
      setIsValid(true);
      setMessage((prevMessage) => {
        return {
          ...prevMessage,
          type: "success",
          message: "Expense added successfully",
        };
      });
      setTimeout(() => {
        setMessage((prevMessage) => {
          return {
            ...prevMessage,
            type: "",
            message: "",
          };
        });
      }, 2000);
      props.onsaveExpenseData(newExpenseData);
    } else if (enteredTitle.trim().length === 0) {
      setIsValid(false);
      setMessage((prevMessage) => {
        return {
          ...prevMessage,
          type: "error",
          message: "Please provide a title",
        };
      });
    } else if (
      enteredAmount.trim().length === 0
    ) {
      setIsValid(false);
      setMessage((prevMessage) => {
        return {
          ...prevMessage,
          type: "error",
          message: "Please provide an amount",
        };
      });
    } else if (enteredDate.trim().length === 0) {
      setIsValid(false);
      setMessage((prevMessage) => {
        return {
          ...prevMessage,
          type: "error",
          message: "Please provide a date",
        };
      });
    } else {
      setMessage((prevMessage) => {
        return {
          ...prevMessage,
          type: "error",
          message: "Invalid details provided",
        };
      });
    }
  };
  return (
    <form
      className={styles["new-expense__form"]}
      onSubmit={submitFormHandler}
    >
      <div
        className={
          styles["new-expense__form__controls"]
        }
      >
        <div
          className={
            styles["new-expense__form__control"]
          }
        >
          <label htmlFor="title">Title</label>
          <Input
            value={enteredValue.enteredTitle}
            onChange={changeTitleHandler}
            type="text"
            id="title"
            className={
              styles[
                "new-expense__form__control__input"
              ]
            }
          />
        </div>
        <div
          className={
            styles["new-expense__form__control"]
          }
        >
          <label htmlFor="amount">Amount</label>
          <Input
            value={enteredValue.enteredAmount}
            onChange={changeAmountHandler}
            type="number"
            id="amount"
            className={
              styles[
                "new-expense__form__control__input"
              ]
            }
          />
        </div>
        <div
          className={
            styles["new-expense__form__control"]
          }
        >
          <label htmlFor="title">Date</label>
          <Input
            value={enteredValue.enteredDate}
            onChange={changeDateHandler}
            type="date"
            id="date"
            min="2018-01-01"
            max="2022-12-31"
            className={
              styles[
                "new-expense__form__control__input"
              ]
            }
          />
        </div>
      </div>
      <NewExpenseFormMessage
        isValid={isValid}
        message={message}
      />
      <div
        className={
          styles["new-expense__form__actions"]
        }
      >
        <Button type="submit">Add Expense</Button>
      </div>
    </form>
  );
};

export default NewExpenseForm;
